module.exports = __webpack_public_path__ + "img/5.e10e0160.png";